export default {
      id: "cargo-temperature-usage",
      viewBox: "0 0 32 45",
      url: __webpack_public_path__ + "img/icons.svg#cargo-temperature",
      toString: function () {
        return this.url;
      }
    }